var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEazidayLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1371,
    height: 422,
    viewBox: "0 0 1371 422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1729_2316)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1729_2316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 352.9L118.867 63.6074H176.041L194.902 65.0384C194.902 65.0384 207.562 65.8996 215.532 67.6618C222.617 69.2285 226.706 69.9556 233.411 73.1472C239.995 76.2816 249.325 83.6409 249.325 83.6409L231.839 78.394C231.839 78.394 221.916 77.0885 215.532 76.7246C207.484 76.2659 202.939 76.0405 194.902 76.7246C187.487 77.3558 183.228 77.5262 176.041 79.825C172.287 81.0256 166.61 83.6409 166.61 83.6409L125.743 182.139H273.099L266.811 204.08L256.595 225.068H106.685L63.6575 326.666L184.489 323.327C184.489 323.327 161.048 337.375 144.998 342.645C129.788 347.639 120.782 348.02 105.114 350.038C90.7401 351.89 68.1764 352.9 68.1764 352.9H0Z",
    fill: "url(#paint0_linear_1729_2316)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1729_2316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.099 44.2887L66.8047 14L261.903 16.1464C261.903 16.1464 285.294 17.1169 300.019 20.2008C309.245 22.1332 314.468 23.2302 323.4 26.6402C334.058 30.7095 349.727 40.2343 349.727 40.2343C349.727 40.2343 366.45 54.9289 374.09 67.6611C379.043 75.9168 384.503 90.5565 384.503 90.5565C384.503 90.5565 388.884 115.82 387.843 132.054C387.139 143.035 383.324 159.72 383.324 159.72C383.324 159.72 376.197 183.368 369.767 197.402C361.704 215.002 355.351 223.581 344.815 239.138C335.917 252.278 330.303 259.871 319.95 271.335C308.522 283.989 301.709 289.571 288.82 299.954L288.22 300.437C280.696 306.5 276.281 310.057 268.19 315.456C258.446 321.959 252.667 324.907 242.452 330.243L242.368 330.287C229.907 336.796 222.847 340.485 209.838 345.268C194.067 351.066 168.578 356 168.578 356C168.578 356 194.446 341.848 209.838 330.243C223.188 320.176 242.452 301.623 242.452 301.623C242.452 301.623 258.868 284.012 268.19 271.335C276.929 259.451 281.538 252.389 288.82 239.138L289.288 238.288C297.374 223.575 302.282 214.645 307.485 198.117C311.708 184.704 314.951 162.82 314.951 162.82C314.951 162.82 316.636 143.94 314.951 132.054C312.524 114.935 309.017 104.465 300.019 90.5565C293.028 79.7513 287.707 74.7557 278.014 67.6611C268.399 60.6234 262.335 57.937 251.513 54.3057C239.914 50.4134 232.778 48.9827 220.841 47.1225C204.181 44.5262 178.009 44.2887 178.009 44.2887H106.099Z",
    fill: "url(#paint1_linear_1729_2316)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1729_2316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.985 265.5V156.409H508.38V170.578H456.445V203.817H504.811V217.933H456.445V251.331H509.019V265.5H439.985ZM554.581 265.5H537.11L576.367 156.409H595.384L634.642 265.5H617.17L586.328 176.224H585.476L554.581 265.5ZM557.511 222.78H614.187V236.629H557.511V222.78ZM662.572 265.5V254.527L719.941 170.578H662.093V156.409H740.076V167.382L682.707 251.331H740.555V265.5H662.572ZM792.656 156.409V265.5H776.196V156.409H792.656ZM866.942 265.5H831.626V156.409H868.06C878.749 156.409 887.929 158.593 895.599 162.961C903.27 167.293 909.147 173.526 913.231 181.658C917.35 189.754 919.41 199.467 919.41 210.795C919.41 222.158 917.332 231.924 913.178 240.092C909.058 248.259 903.092 254.545 895.28 258.948C887.467 263.316 878.021 265.5 866.942 265.5ZM848.085 251.118H866.036C874.346 251.118 881.253 249.555 886.757 246.43C892.261 243.27 896.381 238.707 899.115 232.741C901.849 226.739 903.217 219.424 903.217 210.795C903.217 202.237 901.849 194.974 899.115 189.009C896.416 183.043 892.386 178.515 887.023 175.425C881.661 172.336 875.003 170.791 867.048 170.791H848.085V251.118ZM958.673 265.5H941.201L980.459 156.409H999.475L1038.73 265.5H1021.26L990.42 176.224H989.568L958.673 265.5ZM961.603 222.78H1018.28V236.629H961.603V222.78ZM1049.94 156.409H1068.63L1097.13 206.001H1098.3L1126.8 156.409H1145.5L1105.92 222.673V265.5H1089.52V222.673L1049.94 156.409Z",
    fill: "url(#paint2_linear_1729_2316)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1729_2316",
    x: -20,
    y: 63.6074,
    width: 293.102,
    height: 319.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521569 0 0 0 0 0.0862745 0 0 0 0 0.933333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1729_2316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1729_2316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1729_2316",
    x: 26.8047,
    y: 14,
    width: 361.195,
    height: 362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -30,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521569 0 0 0 0 0.0862745 0 0 0 0 0.933333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1729_2316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1729_2316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1729_2316",
    x: 399.984,
    y: 156.408,
    width: 745.516,
    height: 129.092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -30,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521569 0 0 0 0 0.0862745 0 0 0 0 0.933333 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1729_2316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1729_2316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_2316",
    x1: 136.549,
    y1: 63.6074,
    x2: 136.549,
    y2: 352.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A18F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#300260"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1729_2316",
    x1: 227.404,
    y1: 14,
    x2: 227.404,
    y2: 356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A18F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#300260"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1729_2316",
    x1: 899.5,
    y1: 143.5,
    x2: 899.5,
    y2: 277.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A18F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#300260"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1729_2316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1371,
    height: 422,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEazidayLogo);
export default __webpack_public_path__ + "static/media/eaziday-logo.36dc58af13e4ad4ef0699e6e68af2b18.svg";
export { ForwardRef as ReactComponent };